var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("您访问的地址不存在 "),_c('i',{staticStyle:{"font-size":"1.5em"}},[_vm._v(_vm._s(_vm.count))]),_vm._v(" 秒内返回主页面")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.left}},[_vm._v("点击跳转到home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }